module.exports = "/_next/static/images/Video-8b8c97b14c6bafdad3b5639e6a92954b.png";